module.exports = __webpack_public_path__ + "static/media/QbLogo.6d2230cf.png";